import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Context } from "../../index";
import BasketItem from "./BasketItem";

const BasketList = observer(() => {
    const { product } = useContext(Context)
    return (
        <div className="cart-list">
            {product.basketProducts?.length > 0 ? product.basketProducts?.map(product =>
                <BasketItem key={product.id} basketProduct={product} />
            ) : (<p>Корзина пуста</p>)}
        </div>
    );
});

export default BasketList;